import { render, staticRenderFns } from "./FolioTable.vue?vue&type=template&id=b01c3298"
import script from "./FolioTable.vue?vue&type=script&lang=js"
export * from "./FolioTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports